import { withI18n } from 'react-i18next';
import OneTimeAddress from './OneTimeAddress';

export const pureComponent = OneTimeAddress;
export default withI18n()(OneTimeAddress);
